var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.714,
    height: 19.064,
    viewBox: "0 0 21.714 19.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-chat-945233",
    d: "M18.489,6.13H3.224A3.224,3.224,0,0,0,0,9.359v8.494a3.224,3.224,0,0,0,3.224,3.231H4.343v2.823c0,1.34.806,1.691,1.789.782l3.9-3.6H18.5a3.224,3.224,0,0,0,3.218-3.231V9.359A3.224,3.224,0,0,0,18.489,6.13ZM6.453,15.05a1.249,1.249,0,1,1,1.24-1.231,1.249,1.249,0,0,1-1.24,1.231Zm4.391,0A1.249,1.249,0,1,1,12.1,13.808a1.262,1.262,0,0,1-1.259,1.244Zm4.417,0a1.243,1.243,0,1,1,.882-.368,1.249,1.249,0,0,1-.882.368Z",
    transform: "translate(0 -6.13)",
    fill: "#5a5a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.18836a461eae882b560ee200430b07da.svg";
export { ForwardRef as ReactComponent };